import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import 'bootstrap';
import '@/vendor/fontawesome/fontawesome-free-5.11.2-web/css/all.css';
import 'bootstrap/dist/css/bootstrap.css';
import BootstrapVue from 'bootstrap-vue';
// import web1_request from 'web1-request';


Vue.config.productionTip = true;

Vue.use(BootstrapVue);

Vue.mixin({

   methods: {
      show_error ( c_message ){
         this.$store.dispatch( 'set_message', {
            type: 'error',
            message: { code:500, message: c_message }
         });
      },// /show_error()

      show_problem ( c_message ){
         this.$store.dispatch( 'set_message', {
            type: 'problem',
            message: c_message
         });
      },// /show_problem()

      show_success ( c_message ){
         this.$store.dispatch( 'add_success_message', c_message );
      },// /show_success()

      show_wait ( c_message, n_percent, undefined ){
         if( n_percent == undefined ){
            n_percent = 25;
         }
         
         this.$store.dispatch( 'set_message', {
            type: 'wait',
            message: {percent: n_percent, message: c_message}
         });
      },// /show_wait()

      clear_show (){
         this.$store.dispatch( 'clear_messages' );
      },// /clear_show()
   }
});

new Vue({
   router,
   store,
   render: h => h(App)
}).$mount('#app');
